<button [matMenuTriggerFor]="usermenu" class="profile-button mat-body-medium" (click)="onResetMenu()">
	<app-user-avatar [user]="user()"/>
</button>

<mat-menu #usermenu class="user-menu">
		<app-profile-info/>
  <hr>
		<app-language-select-menu-item/> 
  <hr/>
		<button mat-menu-item
		 (click)="onChangePassword()">
			<ogs-m3-icon icon="key" matButtonIcon/>
			<span class="mat-body-medium">{{"Passwort ändern" | translate : "user-menu-change-password"}}</span>
	</button>
	<hr>
	<button mat-menu-item (click)="onLogout()">
		<ogs-m3-icon icon="power-off" matButtonIcon/>
		<span class="mat-body-medium">{{"Abmelden" | translate : "user-menu-logout"}}</span>
	</button>
</mat-menu>

<!-- <mat-menu #languageMenu xPosition="before" class="language-menu-panel">
  <button mat-menu-item class="button--menu-item" (click)="changeLanguage('de')">Deutsch</button>
  <button mat-menu-item class="button--menu-item" (click)="changeLanguage('en')">English</button>
  <button mat-menu-item class="button--menu-item" (click)="changeLanguage('fr')">Français</button>
</mat-menu> -->
